import { render, staticRenderFns } from "./statistic_flow.vue?vue&type=template&id=3c5c7cac&scoped=true&"
import script from "./statistic_flow.vue?vue&type=script&lang=js&"
export * from "./statistic_flow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5c7cac",
  null
  
)

export default component.exports